import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Loading } from 'secondstep-components'
import { LOADING_LUM_TEXT } from 'lib/constants'
import { operations as siteOperations } from 'store/sitesManager'
import { getNetSuiteAssetsMe } from 'store/netSuiteAssetManager'

import LUMRouter from './component'

const LUMRouterContainer = ({ pushTo }) => {
  const dispatch = useDispatch()

  const {
    areSitesInitialized,
    isLoadingNetSuiteAssets,
    isLoadingSites,
    isLicenseAdmin,
    isSiteAdmin,
    selectedUserLicense,
    sitesData,
  } = useSelector(state => {
    const {
      isLoading: isLoadingNetSuiteAssets,
      netSuiteAssets,
    } = state.netSuiteAssetManager
    const {
      isSiteAdmin,
      sites: {
        isInitialized: areSitesInitialized,
        isLoading: isLoadingSites,
        data: sitesData,
      },
    } = state.sitesManager

    const isLicenseAdmin =
      Array.isArray(netSuiteAssets) && netSuiteAssets.length > 0

    return {
      areSitesInitialized,
      isLoadingNetSuiteAssets,
      isLoadingSites,
      isLicenseAdmin,
      isSiteAdmin,
      selectedUserLicense: netSuiteAssets?.[0] || null,
      sitesData,
    }
  })

  useEffect(() => {
    dispatch(getNetSuiteAssetsMe())
  }, [dispatch])

  useEffect(() => {
    if (sitesData === null) {
      dispatch(siteOperations.fetchSites())
    }
  }, [dispatch, sitesData])

  if (!areSitesInitialized || isLoadingNetSuiteAssets || isLoadingSites) {
    return <Loading dataTestId="loading-lum" loadingText={LOADING_LUM_TEXT} />
  }

  return (
    <LUMRouter
      isLicenseAdmin={isLicenseAdmin}
      isSiteAdmin={isSiteAdmin}
      pushTo={pushTo}
      selectedUserLicense={selectedUserLicense}
      sitesData={sitesData}
    />
  )
}

LUMRouterContainer.propTypes = {
  pushTo: PropTypes.func,
}

export default LUMRouterContainer
